<template>
  <div class="broadcast-history">
    <div class="broadcast-history-header">
      <h4 class="broadcast-history-title">
        Histórico de envios
      </h4>
      <button v-if="!loaded && !loading" @click.prevent="goToBroadcastPage">
        Ver tudo
      </button>
      <Loading :loading="loading" />
    </div>

    <BroadcastHistoryList :machine-id="zap.id" />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

import Loading from '@/components/base/Loading'

import BroadcastHistoryList from './broadcast-history-list'

export default {
  name: 'BroadcastHistory',
  components: { BroadcastHistoryList, Loading },
  data: () => ({
    loaded: false,
    loading: false
  }),
  computed: {
    ...mapState({
      broadcasts: state => state.broadcasts.finalized || [],
      zap: state => state.zaps.zap || {}
    })
  },
  methods: {
    ...mapActions({
      loadBroadcasts: 'broadcasts/load'
    }),
    async getList() {
      this.loading = true
      try {
        await this.loadBroadcasts({
          machine_id: this.zap.id,
          order_by: 'id',
          type_order: 'desc',
          page_size: this.broadcasts.total,
          status: 3
        })

        this.loaded = true
      } catch (_) {}
      this.loading = false
    },
    goToBroadcastPage() {
      this.$router.push({
        name: 'index-broadcast'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'assets/scss/variables';

.broadcast-history {
  &-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: $scale900;
  }

  &-title {
    @include HeadingXSmall;
    font-weight: 600;
    font-family: $monserratFontFamily;
    color: $neutral500;
  }

  ::v-deep .loading-panel {
    height: inherit;

    .loadinfo {
      font-size: 18px;
      margin: 0px;
    }
  }
}
</style>
